import { NativeTypes } from 'react-dnd-html5-backend';
import { useDrop } from 'react-dnd';
const style = {
    // border: '1px solid gray',
    height: '5rem',
    width: '100%',
    padding: '2rem',
    textAlign: 'center',
};
export const FileDragAndDrop = (props) => {
    const { onDrop } = props;
    const [{ canDrop, isOver }, drop] = useDrop(() => ({
        accept: [NativeTypes.FILE],
        drop(item) {
            if (onDrop) {
                onDrop(item);
            }
        },
        canDrop(item) {
            console.log('canDrop', item.files, item.items);
            return true;
        },
        hover(item) {
            console.log('hover', item.files, item.items);
        },
        collect: (monitor) => {
            const item = monitor.getItem();
            if (item) {
                console.log('collect', item.files, item.items);
            }
            return {
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop(),
            };
        },
    }), [props]);
    const isActive = canDrop && isOver;
    return (<div ref={drop} style={style}>
        {isActive ? 'Release to drop' : 'Drag & drop the image in this section'}
    </div>);
};
